import type * as core from '../../../../../core'

export const PACKAGE = {
  contents: [
    'package:data.higherEd.orgStructureSpace',
    'resource:data.enums.assetType',
    'resource:data.enums.assetType.entries.building',
    'resource:data.enums.assetType.entries.fixedEquipment',
    'resource:data.enums.assetType.entries.movableEquipment',
    'resource:data.enums.assetOwnership',
    'resource:data.enums.assetOwnership.entries.leased',
    'resource:data.enums.assetOwnership.entries.owned',
    'resource:data.dimensions.assets',
    'resource:data.dimensions.assets.entities.asset',
    'resource:data.dimensions.assets.entities.asset.attributes.type',
    'resource:data.dimensions.assets.entities.asset.attributes.space',
    'resource:data.dimensions.assets.entities.asset.attributes.ownership',
    'resource:data.dimensions.assets.entities.asset.attributes.organization',
    'resource:data.dimensions.assets.entities.asset.attributes.federalAmount',
    'resource:data.dimensions.assets.entities.asset.attributes.acquisitionDate',
    'resource:data.dimensions.assets.entities.asset.attributes.acquisitionAmount',
  ],
  description: 'TODO',
  name: 'Data - Assets',
} as const satisfies core.quiver.Package
